import { API_CONFIG } from '../brands/default/config';
import { URLCHECKOUTVIEWDATA } from '../brands/default/services';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { getAppPlatform } from './device';

const getPaymentOptions = async ({
  dealId,
  dealVoucherProductId,
  quantity,
}) => {
  try {
    const data = {
      paymentViewRequest: {
        dealProducts: [
          {
            dealVoucherProductId,
            payDeposit: false,
            quantity,
          },
        ],
      },
    };
    const response = await axios(
      `${URLCHECKOUTVIEWDATA}/${dealId}?deliveryOptions=true`,
      {
        cache: false,
        data,
        headers: {
          'app-platform': getAppPlatform(),
          brand: API_CONFIG.BRAND_HEADER,
          'country-code': process.env.NEXT_PUBLIC_COUNTRY_CODE || 'gb',
          webapp: true,
          ...(API_CONFIG.SUB_BRAND && { 'sub-brand': API_CONFIG.SUB_BRAND }),
        },
        method: 'POST',
      },
    );
    if (response) {
      return response.data.data;
    }

    return null;
  } catch {
    return null;
  }
};

export default getPaymentOptions;
